import InitiativeService from 'src/modules/initiative/initiativeService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'INITIATIVE_FORM';

const initiativeFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: initiativeFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await InitiativeService.find(id);
      }

      dispatch({
        type: initiativeFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: initiativeFormActions.INIT_ERROR,
      });

      getHistory().push('/initiative');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: initiativeFormActions.CREATE_STARTED,
      });

      await InitiativeService.create(values);

      dispatch({
        type: initiativeFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.initiative.create.success'),
      );

      getHistory().push('/initiative');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: initiativeFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: initiativeFormActions.UPDATE_STARTED,
      });

      await InitiativeService.update(id, values);

      dispatch({
        type: initiativeFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.initiative.update.success'),
      );

      getHistory().push('/initiative');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: initiativeFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default initiativeFormActions;
